import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import { Icon } from '@sparknz/spark-pattern-library';
import { trackCustomLink } from '@sparknz/tracking';

import { useTrackActionLayerView } from 'components/shop/MobilePlans/components/SelectedPlansActionLayer/hooks/useTrackActionLayerView';
import { MobilePlansDetails } from 'components/shop/MobilePlans/typings/plans';
import { IconText } from 'components/shop/shared/components';
import { INFO_LAYER_CONTENT_QUERY_KEY } from 'shared/constants/query.constants';
import useQuery from 'shared/hooks/useQuery';

export interface SelectQuantityStepHeadingProps {
  iconTitle: string;
  infoDetailsContentKey: string;
  title: string;
  iconAriaLabel: string;
  planCardsProducts: MobilePlansDetails;
  trackingEventName: string;
  onClick?(): void;
}
const SelectQuantityStepHeading: FC<SelectQuantityStepHeadingProps> = ({
  iconTitle,
  infoDetailsContentKey,
  title,
  iconAriaLabel,
  planCardsProducts,
  trackingEventName,
}) => {
  const {
    palette: { baseColors },
  } = useTheme();
  useTrackActionLayerView({
    planDetails: planCardsProducts,
    eventName: trackingEventName,
  });
  const { query: params, replaceQuery } = useQuery();
  return (
    <IconText
      variant="subheadingM"
      mb="s3"
      icon={<Icon name="info_small" fill={baseColors.lupin} />}
      onClick={() => {
        trackCustomLink(iconTitle);
        replaceQuery({
          ...params,
          [INFO_LAYER_CONTENT_QUERY_KEY]: infoDetailsContentKey,
        });
      }}
      ariaLabel={iconAriaLabel}
      title={iconTitle}
    >
      {title}
    </IconText>
  );
};

export default SelectQuantityStepHeading;
